import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const CreateDistiller = React.createContext({});
export let createDistillerMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMCreateDistiller = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  createDistillerMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(createDistillerMachine);

  return {
    createDistillerMachine,
    createDistillerState: state,
    createDistillerSend: send,
  };
};
